import { defineStore } from 'pinia';

export interface NavigationLinksItem {
    id: string;
    name: string;
    appearance: Appearance;
}

export interface NavigationLinks {
    departments: NavigationLinksItem[],
    productGroups: NavigationLinksItem[],
}

export interface Appearance {
    image: string;
    buttonColor: string;
    fontSizes: string;
}

export interface ProductGroup {
    id: string;
    name: string;
    showOnMenu: boolean;
    displayOrder: number;
    usedToRouteOrders: boolean;
    nonDiscountable: boolean;
    nonSurchargeable: boolean;
    appearance: Appearance;
    navigationLinks: NavigationLinks;
    altDisplayLang: String[];
}



export const defaultProductGroup = {
    id: '',
    name: '',
    showOnMenu: false,
    displayOrder: 0,
    nonDiscountable: false,
    nonSurchargeable: false,
    usedToRouteOrders: false,
    appearance: {
        image: '',
        buttonColor: '7',
        fontSizes: 'Medium'
    },
    navigationLinks: {
        departments: [],
        productGroups: []
    },
    altDisplayLang: []
} as ProductGroup;

export const useProductGroupsStore = defineStore('productGroups', {
    state: () => ({
        productGroupList: [] as ProductGroup[],
        activeProductGroup: { ...defaultProductGroup },
        tempActiveProductGroup: { ...defaultProductGroup }
    }),
    getters: {
        getActiveProductGroup: (state) => {
            return state.activeProductGroup;
        },
        getActiveProductGroupId: (state) => {
            return state.activeProductGroup.id;
        },
        findProductGroupById: (state) => (id: string) => {
            return state.productGroupList.find(productGroup => productGroup.id === id);
        },
        getProductGroupsList: (state) => {
            return state.productGroupList;
        },
        getTempActiveProductGroup: (state) => {
            return state.tempActiveProductGroup;
        },
        getIsActiveProductGroupChanged: (state) => {
            return JSON.stringify(state.activeProductGroup) !== JSON.stringify(state.tempActiveProductGroup);
        }
    },
    actions: {
        initializeProductGroups(productGroups: ProductGroup[]) {
            this.productGroupList = productGroups;
        },
        addProductGroup(productGroup: ProductGroup) {
            this.productGroupList.push(productGroup);
        },
        removeProductGroup(id: string) {
            this.productGroupList = this.productGroupList.filter(productGroup => productGroup.id !== id);
            this.activeProductGroup = { ...defaultProductGroup };
            this.tempActiveProductGroup = { ...defaultProductGroup };
        },
        updateProductGroup(updatedProductGroup: ProductGroup) {
            const index = this.productGroupList.findIndex(productGroup => productGroup.id === updatedProductGroup.id);
            if (index !== -1) {
                this.productGroupList[index] = updatedProductGroup;
            }
        },
        setActiveProductGroup(productGroup: ProductGroup) {
            this.activeProductGroup = productGroup;
        },
        setTempActiveProductGroup(productGroup: ProductGroup) {
            this.tempActiveProductGroup = productGroup;
        },
        initActiveProductGroup(productGroup: ProductGroup) {
            this.activeProductGroup = productGroup;
            this.tempActiveProductGroup = productGroup;
        }
    },
});